import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';

export const Cleaning = () => {
  const { cleaningTellUsMoreText, updateCleaningTellUsMoreText } =
    useCycleStore();
  const [textInput, setTextInput] = useState(cleaningTellUsMoreText);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const pageTitle = 'Tell us what needs cleaning and where it is needed ';
  const errorPath = 'cleaningTellUsMore';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = textAreaInputSchema({
          fieldName: errorPath,
          requiredMessage: `Enter details about the cleaning needed.`,
          maxLength: MAX_LENGTH,
          maxLengthMessage: `Details about the cleaning needed must be 500 characters or less.`,
        }).parse({
          [errorPath]: textInput,
        });
        if (validatedData[errorPath]) {
          updateCleaningTellUsMoreText(validatedData[errorPath]);
        }
        navigate(RoutesList.TELL_US_MORE);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_SELECTION);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
